/* eslint-disable max-len */
import { React, Fragment } from 'react'
import Pagination from '../../../../components/Pagination';
import { formatAdjustedDate } from '../../../../CommonMethods/formatDate';

const Table = ({ InventoryStockReportStudentList,
    searchParams,
    setSearchParams,
    setPageLoading,
    handleOnClickSort,
    sortValue,
    reportDate,
    InventoryStockReportStudentCount }) => {
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const urlParams = new URLSearchParams(window.location.search);

    const branchUrl = urlParams.get("sort");
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    return (

        <div class="-mx-1">
            <div className='text-center absolute w-full'>Inventory Stock Report as on <span id='current-date' className="font-semibold">{searchParams?.get('report_date') === null ? formatAdjustedDate(reportDate) : formatAdjustedDate(searchParams?.get('report_date'))}</span></div>
            <div class="flex overflow-auto pb-[6px] scroll-bar px-1 topHeading" id="search-result">
                <table aria-label="Outside Table" class="w-full " id="admin-table">
                    <thead>
                        <tr>
                            <th id="Item Code" class="w-[20%]" onClick={() => {handleSort('item_code')}}>
                                <span >Item Code
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "item_code" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id="Item Name" class="w-[25%]" onClick={() => {handleSort('item_name')}}>
                                <span >Item Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "item_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[15%]">
                                <span >UoM
                                </span>
                            </th>
                            <th class="w-[20%]">
                                <span class="flex items-center justify-end">Closing Stock
                                </span>
                            </th>
                            <th class="w-[20%]">
                                <span class="flex items-center justify-end">Stock Value
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>
                    </thead>
                    <tbody >
                        {InventoryStockReportStudentList?.map((inventory) => (
                            <>
                                <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                <tr class="group">
                                    <td class="text-start">{inventory?.item_code|| '-'}</td>
                                    <td class="text-start">{inventory?.item_name || '-'}</td>
                                    <td class="text-start">{inventory?.uom || '-'}</td>
                                    <td class="text-end">{inventory?.closing_stock_quantity || '-'}</td>
                                    <td class="text-end">{parseFloat(inventory?.closing_stock_amount).toFixed(2) || '-'}</td>
                                </tr>
                            </>))}
                        <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                    </tbody>
                    {InventoryStockReportStudentCount === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Inventory Stock added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            {InventoryStockReportStudentCount > 10 &&  <Pagination
                TotalCount={InventoryStockReportStudentCount}
                totalPageNumber={Math?.ceil(InventoryStockReportStudentCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>
    )
}
export default Table;   